export const environment = import.meta.env.VITE_ENV as 'development' | 'review' | 'staging' | 'production';
export const isProd = environment === 'production';
export const isStaging = environment === 'staging';
export const isDev = environment === 'development';
export const isReview = environment === 'review';

export const GQL_URI = '/graphql';
